/**
 * Wraps a promise with a timeout. If the promise doesn't resolve within
 * the specified timeout, it will reject with a timeout error.
 * 
 * @param {Promise} promise - The promise to wrap with timeout
 * @param {number} timeoutMs - Timeout in milliseconds (default: 4 minutes)
 * @returns {Promise} The promise with timeout applied
 */
export const withTimeout = (promise, timeoutMs = 240000) => {
  let timeoutId;

  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      const minutes = Math.floor(timeoutMs / 60000);
      const seconds = Math.floor((timeoutMs % 60000) / 1000);
      let timeoutMessage;
      if (minutes > 0) {
        timeoutMessage = `Request timed out after ${minutes} minute${minutes !== 1 ? 's' : ''}`;
      } else if (seconds > 0) {
        timeoutMessage = `Request timed out after ${seconds} second${seconds !== 1 ? 's' : ''}`;
      } else {
        timeoutMessage = `Request timed out after ${timeoutMs}ms`;
      }
      reject(new Error(timeoutMessage));
    }, timeoutMs);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    // Clear the timeout to prevent memory leaks
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  });
};
